import { useState } from 'react';
import {AccessTime, Assignment, Description, Folder, FolderOpen ,Link} from "@mui/icons-material";

const useDocumentManagement = () => {
    const [menuItems] = useState([
        {
            title: 'Documents en attente',
            path:"docenattent",
            icon: <AccessTime sx={{ fontSize: 40, color: '#1976d2' }} />,
            bgColor: '#fff3c4',
            iconBg: '#ffd54f',
        },
        {
            title: 'Documents clients',
            path:"docclient",
            icon: <Folder sx={{ fontSize: 40, color: '#8b4513' }} />,
            bgColor: '#fff3c4',
            iconBg: '#ffd54f',
        },
        {
            title: 'Classement des documents',
            path:"docclasse",
            icon: <FolderOpen sx={{ fontSize: 40, color: '#666' }} />,
            bgColor: '#fff3c4',
            iconBg: '#ffd54f',
        },
        {
            title: 'Mes documents',
            path:"mesdocuments",
            icon: <Assignment sx={{ fontSize: 40, color: '#333' }} />,
            bgColor: '#fff3c4',
            iconBg: '#ffd54f',
        },
        {
            title: 'Liens clients',
            path:"lienclient",
            icon: <Link sx={{ fontSize: 40, color: '#1976d2' }} />,
            bgColor: '#fff3c4',
            iconBg: '#ffd54f',
        },
        {
            title: 'Types de documents',
            path :"typedoc",
            icon: <Description sx={{ fontSize: 40, color: '#666' }} />,
            bgColor: '#fff3c4',
            iconBg: '#ffd54f',
        },
    ]);

    const handleCardClick = (path) => {
        console.log(`Navigating to ${path}`);
    };

    return { menuItems, handleCardClick };
};

export default useDocumentManagement;